import React from 'react';
import { BedIcon, BathIcon, EnsuiteIcon, GarageIcon, CarportIcon, ParkingIcon, EerIcon } from '@domain-group/fe-co-icon';
import { PropertyType, ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { PriceGuidePill } from '@domain-group/fe-co-allhomes-shared-components';
import { Item, Icons, PropertyTypeLabel, Value, itemIcon, FeatureIconContainer, MobileFirstRow, MobileSecondRow } from './feature-icons.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var FeatureIcons = _ref => {
  var _ref$propertyType = _ref.propertyType,
    propertyTypeName = _ref$propertyType === void 0 ? null : _ref$propertyType,
    _ref$beds = _ref.beds,
    beds = _ref$beds === void 0 ? 0 : _ref$beds,
    _ref$baths = _ref.baths,
    baths = _ref$baths === void 0 ? 0 : _ref$baths,
    _ref$ensuite = _ref.ensuite,
    ensuite = _ref$ensuite === void 0 ? 0 : _ref$ensuite,
    _ref$garage = _ref.garage,
    garage = _ref$garage === void 0 ? 0 : _ref$garage,
    _ref$carport = _ref.carport,
    carport = _ref$carport === void 0 ? 0 : _ref$carport,
    _ref$parking = _ref.parking,
    parking = _ref$parking === void 0 ? 0 : _ref$parking,
    eer = _ref.eer,
    priceGuide = _ref.priceGuide;
  var _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  function renderFeatureIcon(value, icon, title) {
    var Icon = icon;
    if (value) {
      return ___EmotionJSX(Item, null, ___EmotionJSX(Value, null, value), ___EmotionJSX(Icon, {
        size: "regular",
        title: title,
        css: itemIcon
      }));
    }
    return null;
  }
  var propertyType = propertyTypeName && PropertyType[propertyTypeName];
  return ___EmotionJSX(Icons, {
    "data-testid": "feature-icons"
  }, ___EmotionJSX(MobileFirstRow, null, propertyType && ___EmotionJSX(PropertyTypeLabel, null, propertyType.label), ___EmotionJSX(FeatureIconContainer, null, renderFeatureIcon(beds, BedIcon, 'bedrooms'), renderFeatureIcon(baths, BathIcon, 'bathrooms'), renderFeatureIcon(ensuite, EnsuiteIcon, 'ensuites'), renderFeatureIcon(garage, GarageIcon, 'garage spaces'), renderFeatureIcon(carport, CarportIcon, 'carport spaces'), renderFeatureIcon(parking, ParkingIcon, 'parking spaces'), renderFeatureIcon(eer === null || eer === void 0 ? void 0 : eer.toFixed(1), EerIcon, 'EER'))), (toggledFeatures === null || toggledFeatures === void 0 ? void 0 : toggledFeatures[ToggledFeatureKey.PRICE_GUIDE]) && priceGuide && ___EmotionJSX(MobileSecondRow, null, ___EmotionJSX(PriceGuidePill, {
    priceGuide: priceGuide
  })));
};